export default "__VITE_ASSET__BXt1S9Po__"